module.exports = __webpack_public_path__ + "img/1.edd2d1a3.jpg";